<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row c-alert c-alert--info mb-3" *ngIf="isIntegrationError">
  <div class="c-alert__msg">
    <i class="fa-light fa-circle-info mr-2 f-16 align-self-start"></i>
    <div>
      Your email integration encountered an error. Reconnect your account to resume your campaigns. <br>
      <strong>Note:</strong> Only campaigns paused within the last 7 days will be resumed.
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 wccard py-2">
    <div class="d-flex justify-content-between mb-1 mt-1">
      <div class="d-flex">
        <!-- <i class="fas fa-arrow-left mr-3 mt-1 pointer" routerLink="/old-settings"> </i> -->
        <span class="f-14 mt-3px font-weight-500 d-flex justify-content-between pointer"> Integration
        </span>
      </div>
    </div>
  </div>
</div>

<div class="row" style="margin-top: 3px !important;">
  <div class="col d-flex justify-content-between wccard py-3">
    <div class="col d-flex justify-content-between">
      <div class="mt-3 mr-3">
        <img src="../../../assets/gmail.png" style=" width: 40px;height: 30px;" alt="" srcset="" title="make active">
      </div>

      <div class="col">
        <p class="text-webbtree-green text-capitalize f-14 mb-1">Gmail</p>
        <p class="mb-1 gray-text f-12"> Send emails to your candidates using your official ID if you use G Suite.</p>
        <p class="text-webbtree-green mr-1 f-14 font-weight-500">  {{gmailAccountDetails?.emailid}} </p>
      </div>

    </div>
    <div class="mt-4">
      <button data-testid="auto-app-email-integration-button-1" class="btn-trms-medium mx-auto" *ngIf="!gmailAccountDetails?.emailid"  (click)="connectoGmail()">Connect</button>
      <a data-testid="auto-app-email-integration-a-1" class="cvbtn text-webbtree-green mr-1 f-16  px-6 font-weight-500" *ngIf="gmailAccountDetails?.emailid"  (click)="disconnectEmailIntegration()">Disconnect</a>
    </div>
  </div>
</div>

<div class="row" style="margin-top: 3px !important;">
  <div class="col d-flex justify-content-between wccard py-3">
    <div class="col d-flex justify-content-between">
      <div class="mt-3 mr-3">
        <img src="../../../assets/ourtlook.png" style=" width: 40px;height: 40px;" alt="" srcset="" title="make active">
      </div>

      <div class="col">
        <p class="text-webbtree-green text-capitalize f-14 mb-1">Outlook</p>
        <p class="mb-1 gray-text f-12"> Send emails to your candidates using your official ID if you use Microsoft Outlook.</p>
        <p class="text-webbtree-green mr-1 f-14 font-weight-500">  {{outlookAccountDetails?.emailid}} </p>
      </div>

    </div>
    <div class="mt-4">
      <button data-testid="auto-app-email-integration-button-2" class="btn-trms-medium mx-auto" *ngIf="!outlookAccountDetails?.emailid"  (click)="connectoOutlook()">Connect</button>
      <a data-testid="auto-app-email-integration-a-2" class="cvbtn text-webbtree-green mr-1 f-16  px-6 font-weight-500" *ngIf="outlookAccountDetails?.emailid"  (click)="disconnectEmailIntegration('outlook')">Disconnect</a>
    </div>
  </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="warningMessage" type="warning" (close)="warningMessage = ''">
  <!-- <span class="warningCheck"><i class="fal fa-times"></i></span> -->
  <span class="warningmsg">
    <i style="color: #FF9B05;" class="fa-sharp-duotone fa-light fa-circle-exclamation mr-1"></i>
    Oops! Something went wrong. Please contact us at
    support@webbtree.com for assistance.
  </span>
</ngb-alert>
